import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ModalFooter from '@Client/runner.shared/modal/Footer/Footer';
import ModalHeader from '@Client/runner.shared/modal/Header/Header';
import { useService } from '@Client/runner.hooks/useService';
import { SharedAngular } from '@Client/@types/sharedAngular';
import { Guid } from '@Shared.Angular/@types/guid';

type Props = {
  id: Guid;
  name: string;
  hasTagInUse: boolean;
  deleteSuccess: () => void;
  closeModal: () => void;
};

const TagGroupDeleteModal = (props: Props) => {
  const { name, id, hasTagInUse, deleteSuccess, closeModal } = props;
  const [deleteText, setDeleteText] = useState('');
  const [deleteButtonEnabled, setDeleteButtonEnabledStatus] = useState(false);

  useEffect(() => {
    setDeleteButtonStatus();
  }, [deleteText]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDeleteText(event.target.value);
  };

  const setDeleteButtonStatus = () => {
    if (hasTagInUse) {
      setDeleteButtonEnabledStatus(false);
      return;
    }
    if (deleteText.toLowerCase() !== 'delete') {
      setDeleteButtonEnabledStatus(false);
      return;
    }
    setDeleteButtonEnabledStatus(true);
  };

  const categoryApiService =
    useService<SharedAngular.TagGroupApiService>('tagGroupApiService');

  const notificationService = useService<SharedAngular.NotificationService>(
    'notificationService'
  );

  const appInsightsService =
    useService<SharedAngular.AppInsightsService>('appInsightsService');

  const deleteTagGroup = async () => {
    appInsightsService.startEventTimer('setupTaggroupsDeleted');
    try {
      await categoryApiService.delete(id);
      deleteSuccess();
      notificationService.showSuccessToast('Tag Group deleted successfully');
    } catch (error) {
      console.error(error);
      notificationService.showErrorToast(error.data.message);
    }
  };

  return (
    <Box>
      <ModalHeader title="Delete Tag Group"></ModalHeader>
      <br />
      {
        <Box>
          <div>
            <fieldset
              className="setup-tag-groups-delete-modal-fieldset"
              style={{ padding: '15px 15px 30px' }}
            >
              <legend className="setup-tag-groups-delete-modal-legend">
                <b>Warning</b>
              </legend>
              <div>
                You are about to delete <b>{name}</b>.
              </div>
              <div>This cannot be undone!</div>
              <br />

              <div className="delete-warnings-container">
                {hasTagInUse ? (
                  <span>
                    <i
                      className="fa-light fa-triangle-exclamation setup-tag-groups-delete-modal-warning-icon"
                      aria-hidden="true"
                    ></i>
                    &nbsp; You cannot delete this Tag Group because some of its
                    Tags are being used.
                  </span>
                ) : (
                  ''
                )}
              </div>
              {!hasTagInUse && (
                <>
                  <div>
                    Type <b>DELETE</b> to continue
                  </div>
                  <input
                    id="delete-modal"
                    className="setup-tag-groups-delete-modal-textfield"
                    type="text"
                    value={deleteText}
                    onChange={handleInputChange}
                  />
                </>
              )}
            </fieldset>
          </div>
        </Box>
      }
      <ModalFooter
        actionButtonText="Delete Tag Group"
        actionButtonType="Danger"
        isActionDisabled={!deleteButtonEnabled}
        onCancelClick={closeModal}
        onActionClick={deleteTagGroup}
      ></ModalFooter>
    </Box>
  );
};

export default TagGroupDeleteModal;
